// 模块曝光事件埋点
function module_show_tracking(obj) {
  if (!obj.el || !('IntersectionObserver' in window)) return;

  var fired = false;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!fired && entry.intersectionRatio >= 0.5) {
        fired = true;
        observer.disconnect();
        if (typeof gtag === 'function') {
          gtag('event', 'module_show', {
            module_id: obj.module_id,
            module_name: obj.module_name
          });
        }
      }
    });
  }, { threshold: 0.5 });
  observer.observe(obj.el);
}


// 按钮点击事件上报
function btn_click_tracking(obj) {
  if (!obj || !obj.button_name) {
    return;
  }

  obj.el.addEventListener('click', function() {
    console.log('点击上报', obj.button_name)
    gtag('event', 'button_click', {
      el: obj.el,
      button_name: obj.button_name,
      page_name: obj.page_name
    });
  });
}

// 用户停留时长统计上报
function user_action_tracking() {
  var pageStartAt = Date.now();
  var hasLoggedStayTime = false;

  function logPageStayTime(trigger) {
    if (hasLoggedStayTime) return;
    hasLoggedStayTime = true;

    var stayTimeMs = Date.now() - pageStartAt;
    console.log('用户停留时长统计上报', Number((stayTimeMs / 1000).toFixed(2)));
    gtag('event', 'browse_duration_segment_report', {
      browse_duration: Number((stayTimeMs / 1000).toFixed(2)),
      page_name: 'home_page'
    });
  }

	// Trigger only when user leaves current page (refresh/close/tab close/navigation away).
	window.addEventListener('pagehide', function () {
		logPageStayTime('pagehide');
	});

	// Fallback for environments where pagehide may be unreliable.
	window.addEventListener('beforeunload', function () {
		logPageStayTime('beforeunload');
	});
}

// 表单(首次输入、提交、提交失败、提交成功)事件上报
function form_tracking() {
  let allowedEvents = [
    'form_start_1',
    'form_submit_click',
    'form_submit_success',
    'form_submit_fail'
  ];
  window.addEventListener('message', function (e) {
		var eventName = '';
		var errorMessage = '';

		if (typeof e.data === 'string') {
			eventName = e.data;
		} else if (e.data && typeof e.data === 'object') {
			eventName = e.data.eventName || '';
			errorMessage = e.data.error_msg || '';
		}

		if (!allowedEvents.includes(eventName)) return;

		var eventPayload = {
			form_id: 'lead_form',
			form_name: 'lead_form',
			page_name: 'home_page'
		};

		if (eventName === 'form_submit_fail') {
			eventPayload.error_type = e.data.error_type || 'validation_error';
			if (errorMessage) eventPayload.error_msg = errorMessage;
		}

		gtag('event', eventName, eventPayload);
  });
}

// 顶部导航栏菜单点击事件上报
function nav_menu_tracking() {
  var nav = document.querySelector('.header__inline-menu');
	if (nav) {
    nav.addEventListener('click', function (e) {
			var clicked = e.target.closest('a, li');
			if (!clicked || !nav.contains(clicked)) return;
			var menuItem = clicked.closest('li');
			var label = '';
			if (menuItem) {
				var link = menuItem.querySelector('a');
				label = (link ? link.textContent : menuItem.textContent) || '';
			} else {
				label = clicked.textContent || '';
			}
			label = label.replace(/\s+/g, ' ').trim();
			if (label) {
				console.log(label)
				gtag('event', 'button_click', {
					button_name: label,
					page_name: 'home_page'
				});
			}
    });
	}
}

// ins模块点击事件上报
function ins_tracking() {
	const el = document.getElementsByClassName('social-feed__button')?.[0]
	if (el) {
		el.addEventListener('click', () => {
			console.log('@firefly.norge')
			gtag('event', 'button_click', {
				button_name: '@firefly.norge',
				page_name: 'home_page'
			});
		})
	}
}

// 页脚点击事件上报
function footer_tracking() {
	var footer = document.querySelector('.custom-footer__grid');
	if (!footer) return;

	function getSocialChannel(href) {
		var url = (href || '').toLowerCase();
		if (url.indexOf('instagram.com') > -1) return 'ins_icon';
		if (url.indexOf('facebook.com') > -1) return 'facebook_icon';
		if (url.indexOf('linkedin.com') > -1) return 'linkedin_icon';
		return '';
	}

	footer.addEventListener('click', function (e) {
		var btn = e.target.closest('.custom-footer__newsletter-btn');
		if (btn && footer.contains(btn)) {
			var btnLabel = (btn.textContent || '').replace(/\s+/g, ' ').trim();
			if (btnLabel) {
				console.log(btnLabel)
				gtag('event', 'button_click', {
					button_name: btnLabel,
					page_name: 'home_page'
				});
			}
			return;
		}

		var link = e.target.closest('a');
		if (!link || !footer.contains(link)) return;

		if (link.classList.contains('custom-footer__social-link')) {
			var channel = getSocialChannel(link.getAttribute('href'));
			if (channel) {
				console.log(channel)
				gtag('event', 'button_click', {
					button_name: channel,
					page_name: 'home_page'
				});
			}
			return;
		}

		var label = (link.textContent || '').replace(/\s+/g, ' ').trim();
		if (!label) {
			label = (link.getAttribute('title') || '').trim();
		}
		if (!label) {
			label = (link.getAttribute('href') || '').trim();
		}

		if (label) {
			console.log(label)
			gtag('event', 'button_click', {
				button_name: label,
				page_name: 'home_page'
			});
		}
	});
}

// leads表单悬浮按钮点击事件上报
function floating_btn_tracking() {
	const el = document.getElementsByClassName('floating-btns__item')?.[0]
	if (el) {
		el.addEventListener('click', () => {
			gtag('event', 'button_click', {
				button_name: 'interesseskjema',
				page_name: 'home_page'
			});
		})
	}
}


document.addEventListener('DOMContentLoaded', function () {
    form_tracking()
    user_action_tracking()
    // 线索表单曝光上报
    module_show_tracking({
			el: document.getElementById('leads-form'),
			module_name: 'lead_form',
			module_id: 'template--21109024260281__1773713906b2f51f77'
    })
    // 新闻模块曝光上报
    module_show_tracking({
			el: document.getElementById('shopify-section-template--21109024260281__177380194695d1c98d'),
			module_name: 'ins',
			module_id: 'template--21109024260281__177380194695d1c98d'
    })
    // 页脚曝光上报
    module_show_tracking({
			el: document.getElementById('shopify-section-sections--21109019738297__footer'),
			module_name: 'footer',
			module_id: 'shopify-section-sections--21109019738297__footer'
    })
    // banner曝光上报
    module_show_tracking({
			el: document.getElementById('shopify-section-template--21109024260281__hero-video'),
			module_name: 'banner',
			module_id: 'shopify-section-template--21109024260281__hero-video',
			position: '1'
    })
    module_show_tracking({
			el: document.getElementById('shopify-section-template--21109024260281__flexible_banner_t9iGjR'),
			module_name: 'banner',
			module_id: 'shopify-section-template--21109024260281__flexible_banner_t9iGjR',
			position: '2'
    })
    module_show_tracking({
			el: document.getElementById('shopify-section-template--21109024260281__flexible_banner_LJtVgr'),
			module_name: 'banner',
			module_id: 'shopify-section-template--21109024260281__flexible_banner_LJtVgr',
			position: '3'
    })
    nav_menu_tracking()	// 导航栏按钮点击事件上报
    ins_tracking()	// ins模块入口按钮点击事件上报
		footer_tracking()	// 页脚点击事件上报
		floating_btn_tracking() // 悬浮按钮点击事件上报
})

